import { render, staticRenderFns } from "./UiShowcase.vue?vue&type=template&id=d0160fe4"
import script from "./UiShowcase.vue?vue&type=script&lang=js"
export * from "./UiShowcase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports